import { Palette } from '@mui/material';

export const getMixins = (palette: Palette) => {
  return {
    MuiDataGrid: {
      ...(palette.theme !== 'lio' && {
        pinnedBackground: palette.dataGrid.background,
        containerBackground: palette.dataGrid.headerBackground ?? palette.dataGrid.background,
      }),
    },
  };
};
